module.exports = "<div class=\"wrapper bar\">\n  <div class=\"progress\" [style.width]=\"progressPercentage + '%'\">\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/upload-progress-bar/upload-progress-bar.component.html
// module id = ../../../../../src/app/shared/components/upload-progress-bar/upload-progress-bar.component.html
// module chunks = 12